import { config } from "../config"

// This file is a copy of an existing NLP implementation that will be centralized in the future
export type BusinessUnit = "Noordhoff" | "Liber" | "Plantyn"
export const businessUnits: readonly BusinessUnit[] = ["Noordhoff", "Liber", "Plantyn"]

const storageKey = config.businessUnitKey

export const setBusinessUnit = (businessUnit: BusinessUnit) => {
  localStorage.setItem(storageKey, businessUnit)
}

export const getBusinessUnit = (): BusinessUnit => {
  const {
    location: { hostname }
  } = window
  if (hostname !== "localhost") {
    const [, domain] = hostname.split(".").reverse()
    const businessUnit = businessUnits.find((businessUnit) => businessUnit.toLowerCase() === domain)
    if (businessUnit) {
      return businessUnit
    }
  }

  const storedBusinessUnit = localStorage.getItem(storageKey)
  return businessUnits.find((businessUnit) => businessUnit === storedBusinessUnit) || "Noordhoff"
}
